import { Component, Input, OnChanges } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { FirebaseAuthService } from 'src/app/shared/providers/firebase-auth.service';
import { RenderJob } from '../render-flow.model';
import { RenderFeedbackRating, RenderFeedbackService } from '../render-feedback.service';
import { RenderOrientation } from '../render.data';
import { openRenderFeedback } from './render-rating.component';

// The thumbs on one of the preview's frames (designer, Figma 28547:27273: 28721:44956 on the display,
// 28753:46102 on the phone; owner 2026-10-20, the phone too 2026-10-21): up sends a like — an email
// to the team, the way the form goes; down opens the form, which may go empty, and the dislike goes
// with Send (Back drops it). Each frame is rated on its own. The chosen thumb fills and stays
// filled for this model and frame on this device; the other one can still change it.
@Component({
  selector: 'app-render-vote',
  templateUrl: './render-vote.component.html',
  styleUrls: ['./render-vote.component.scss'],
})
export class RenderVoteComponent implements OnChanges {
  @Input() job?: RenderJob;
  @Input() orientation: RenderOrientation = 'landscape';

  public rating: RenderFeedbackRating | null = null;
  public busy = false;
  public failed = false;

  constructor(
    private readonly dialog: MatDialog,
    private readonly feedback: RenderFeedbackService,
    private readonly firebaseAuth: FirebaseAuthService,
  ) {}

  ngOnChanges(): void {
    this.rating = this.job ? this.feedback.rating(this.job, this.orientation) : null;
  }

  // Filled at once; back as it was if it did not go through.
  public async like(): Promise<void> {
    if (!this.job || this.busy || this.rating === 'like') {
      return;
    }
    const before = this.rating;
    this.busy = true;
    this.failed = false;
    this.rating = 'like';
    try {
      await this.feedback.send(this.job, { stage: 'preview', rating: 'like', improve: [], orientation: this.orientation, text: '' });
    } catch {
      this.rating = before;
      this.failed = true;
    } finally {
      this.busy = false;
    }
  }

  public dislike(): void {
    if (!this.job || this.busy || this.rating === 'dislike') {
      return;
    }
    this.failed = false;
    openRenderFeedback(this.dialog, this.firebaseAuth, { job: this.job, stage: 'preview', rating: 'dislike', orientation: this.orientation }).afterClosed().subscribe(() => this.ngOnChanges());
  }
}
